import { put } from 'redux-saga/effects'
import { push } from 'connected-react-router';
import triggerAPI from "../services/triggerAPI";
import { commonError } from "../../src/helper/constant"
import { endpoints } from '../services/endpoints';
import { ORDER_HISTORY_RESPONSE, ORDER_HISTORY_RESPONSE_FAIL } from '../redux/types/orderbook';
let call = new triggerAPI();

export function* orderBook({ payload, resolve }) {
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.orderbook.GetLastFiveTran);
        console.log("data in orderbook api", data)
        if (data.success) {
            let response = data.data;
            let apiData = ""
            if (response.hasOwnProperty("data")) {
                apiData = response.data
            } else {
                apiData = response || []
            }
            yield put({ type: ORDER_HISTORY_RESPONSE, payload: apiData })
            resolve && resolve(apiData)
        }
        else {
            resolve && resolve([])
            yield put({ type: ORDER_HISTORY_RESPONSE_FAIL, payload: data })
        }
    } catch (e) {
        yield put({ type: ORDER_HISTORY_RESPONSE_FAIL, payload: commonError })
    }
}